import styles from './other.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Title from '@/components/_custom/Title/title'
import { SystemUpdateAlt } from '@mui/icons-material'
import Link from '@/components/_custom/Link/Link.tsx'
import Realistic from 'react-canvas-confetti/dist/presets/realistic'
import LoggedOutNav from '@/components/Nav/LoggedOutNav/LoggedOutNav.tsx'
import CachedIcon from '@mui/icons-material/Cached'
import Mobile from '@/modules/desktopMobile/mobile.tsx'
import Desktop from '@/modules/desktopMobile/desktop.tsx'
import { removeServiceWorker } from '@/modules/utils/serviceWorker.ts'

interface UpdateAvailableProps {
    platform: 'ios' | 'android' | 'web'
}

const UpdateAvailable: FunctionComponent<UpdateAvailableProps> = ({ platform }: UpdateAvailableProps) => {
    const { t } = useTranslation()

    return (
        <main>
            <LoggedOutNav hideRefresh />
            <Realistic autorun={{ speed: 0.15 }} />
            <Mobile>
                <Link
                    target='_blank'
                    href={
                        platform === 'ios'
                            ? 'https://apps.apple.com/fr/app/cr%C3%A8che-a-la-demande/id1600278008'
                            : 'https://play.google.com/store/apps/details?id=fr.crechealademande.app'
                    }
                >
                    <div className={styles.Main}>
                        <CachedIcon className={styles.Icon} />
                        <Title text={t('newUpdateAvailable')} />
                        <div className={styles.BreakLine}></div>
                        <ButtonTextIcon
                            type='custom'
                            customText={t('download')}
                            customIcon={<SystemUpdateAlt />}
                            className={styles.Button}
                        />
                    </div>
                </Link>
            </Mobile>
            <Desktop>
                <div className={styles.Main}>
                    <CachedIcon className={styles.Icon} />
                    <Title text={t('newUpdateAvailable')} />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('refresh')}
                        customIcon={<CachedIcon />}
                        onClick={removeServiceWorker}
                        className={styles.ButtonDesktop}
                    />
                </div>
            </Desktop>
        </main>
    )
}

export default UpdateAvailable
